import { useEffect, useMemo, useRef } from "react"
import { useQuery } from "@tanstack/react-query"

const dashboardRetryDelay = (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 3000)

const useDashboardQuery = (queryKey, queryFn, options = {}) => {
  const queryKeySignature = useMemo(() => JSON.stringify(queryKey), [queryKey])
  const hasRetriedRef = useRef(false)

  const query = useQuery(queryKey, queryFn, {
    retry: 2,
    retryDelay: dashboardRetryDelay,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    retryOnMount: true,
    ...options,
  })

  useEffect(() => {
    hasRetriedRef.current = false
  }, [queryKeySignature])

  useEffect(() => {
    if (!query.isError || query.isFetching || hasRetriedRef.current) {
      return
    }

    hasRetriedRef.current = true
    query.refetch()
  }, [query.isError, query.isFetching, query.refetch])

  return query
}

export default useDashboardQuery